import {useCallback, useRef} from "react";

import {ITrackAmplitudeComponentActionParams, trackAmplitudeComponentAction} from "./track_amplitude_component_action";

const getTrackingKey = (params: ITrackAmplitudeComponentActionParams) =>
    [params.componentName, params.action ?? "first_interaction", params.location, params.itemId, params.propertyId ?? "null"].join(":");

export const useTrackAmplitudeComponentActionOnce = (params: ITrackAmplitudeComponentActionParams) => {
    const trackedKeyRef = useRef<string | null>(null);
    const paramsRef = useRef(params);
    const trackingKey = getTrackingKey(params);

    paramsRef.current = params;

    return useCallback(() => {
        if (trackedKeyRef.current === trackingKey) {
            return;
        }

        trackedKeyRef.current = trackingKey;
        trackAmplitudeComponentAction(paramsRef.current);
    }, [trackingKey]);
};
import {useCallback, useRef} from "react";

import {ITrackAmplitudeComponentActionParams, trackAmplitudeComponentAction} from "./track_amplitude_component_action";

const getTrackingKey = (params: ITrackAmplitudeComponentActionParams) =>
    [params.componentName, params.action ?? "first_interaction", params.location, params.itemId, params.propertyId ?? "null"].join(":");

export const useTrackAmplitudeComponentActionOnce = (params: ITrackAmplitudeComponentActionParams) => {
    const trackedKeyRef = useRef<string | null>(null);
    const paramsRef = useRef(params);
    const trackingKey = getTrackingKey(params);

    paramsRef.current = params;

    return useCallback(() => {
        if (trackedKeyRef.current === trackingKey) {
            return;
        }

        trackedKeyRef.current = trackingKey;
        trackAmplitudeComponentAction(paramsRef.current);
    }, [trackingKey]);
};
